import { useWebSocket } from '../hooks/useWebSocket';

// 권위: ARCH_DASHBOARD §6.4 "연결 끊김 배너: 상단 고정 표시"
export function ConnectionBanner(): JSX.Element | null {
  const { status } = useWebSocket();
  if (status === 'connected' || status === 'connecting') return null;
  return (
    <div className={`connection-banner connection-banner--${status}`} role="status">
      {status === 'reconnecting' && '실시간 연결이 끊어졌습니다. 재연결 중...'}
      {status === 'offline' && '실시간 연결이 없습니다.'}
    </div>
  );
}
